

<div class="d-flex justify-content-between align-items-center">
  <div>
    Database ID：{{vector_store_id}} |
    Files Count：{{filecount}}
  </div>
  <div>
    <button *ngIf="hasChangedTags" type="button" class="btn btn-success me-2" (click)="saveTagChanges()" [disabled]="isSubmitting">
      <i class="fa-solid fa-save mx-1"></i>{{isSubmitting ? 'Saving...' : 'Save Tags'}}
    </button>
    <button *ngIf="havedeletefile" type="button" class="btn btn-danger me-2" data-bs-toggle="modal" data-bs-target="#deleteConfirmModal">
      <i class="fa-regular fa-trash-can mx-1"></i>Delete
    </button>
    <app-fileuploader [vectorStoreId]="vector_store_id" [existFileList]="existFileList"></app-fileuploader>
  </div>
</div>

<!-- Tag 篩選器 -->
<div class="mt-2 mb-2">
  <label>key word：</label>
  <input type="text" [(ngModel)]="searchText" placeholder="" class="form-control d-inline-block" style="width: 250px; max-width: 60%;">
</div>


<div *ngIf="filelist.length > 0" class="table-responsive mt-2">

  <!-- 批次操作區塊 -->
  <div class="mb-2 d-flex align-items-center gap-2">
    <button class="btn btn-primary btn-sm me-1"
      [disabled]="selectedFileIds.size === 0"
      data-bs-toggle="modal" data-bs-target="#batchAddTagModal">
      Add Tags
    </button>
    <button class="btn btn-danger btn-sm"
      [disabled]="selectedFileIds.size === 0"
      (click)="prepareBatchRemoveTagList()"
      data-bs-toggle="modal" data-bs-target="#batchRemoveTagModal">
      Remove Tags
    </button>
    <span class="ms-2 text-muted" *ngIf="selectedFileIds.size > 0">Choosed: {{selectedFileIds.size}} </span>
  </div>

  <!-- 批次加入Tag Modal -->
  <div class="modal fade" id="batchAddTagModal" tabindex="-1" aria-labelledby="batchAddTagModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="batchAddTagModalLabel">批次加入Tag</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <label>請輸入要加入的Tag（可輸入多個，以逗號、空白或換行分隔）：</label>
          <textarea [(ngModel)]="batchAddTagsInput" class="form-control" rows="3" placeholder="tag1, tag2, tag3"></textarea>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
          <button type="button" class="btn btn-primary" (click)="confirmBatchAddTag()" data-bs-dismiss="modal" [disabled]="!batchAddTagsInput.trim()">加入</button>
        </div>
      </div>
    </div>
  </div>

  <!-- 批次移除Tag Modal -->
  <div class="modal fade" id="batchRemoveTagModal" tabindex="-1" aria-labelledby="batchRemoveTagModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="batchRemoveTagModalLabel">批次移除Tag</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <label>請選擇要移除的Tag：</label>
          <div *ngIf="batchRemoveTagList.length > 0; else noTags">
            <div *ngFor="let tag of batchRemoveTagList">
              <input type="checkbox" [(ngModel)]="batchRemoveSelectedTags[tag]" id="removeTag_{{tag}}">
              <label for="removeTag_{{tag}}">{{ tag }}</label>
            </div>
          </div>
          <ng-template #noTags>
            <div class="text-muted">所選檔案沒有可移除的Tag。</div>
          </ng-template>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
          <button type="button" class="btn btn-danger" (click)="confirmBatchRemoveTag()" data-bs-dismiss="modal"
            [disabled]="!hasBatchRemoveSelectedTags()">移除</button>
        </div>
      </div>
    </div>
  </div>

  <table class="table table-bordered">
    <thead>
      <tr>
        <th>
          <input type="checkbox"
            [checked]="isAllSelected()"
            (change)="toggleSelectAll($event)">
        </th>
        <th></th>
        <th>No.</th>
        <th>ID</th>
        <th>Filename</th>
        <th>Size (bytes)</th>
        <th>Created At</th>
        <th>Status</th>
        <th>Tags</th>
      </tr>
    </thead>
    <tbody>
      <!-- 迭代 filteredFileList -->
      <tr *ngFor="let file of filteredFileList; let i = index"
    [ngClass]="{'trdeleted': file.deleted, 'tag-changed-row': changedTags.has(file.id)}">
        <td>
          <input type="checkbox"
            [checked]="selectedFileIds.has(file.id)"
            (change)="toggleFileSelection(file.id, $event)">
        </td>
        <th>
          <a style="cursor: pointer;" (click)="deleteFile(file.id)">
            <i class="fa-solid fa-trash-can"></i>
          </a>
        </th>
        <td [ngStyle]="{'text-decoration': file.deleted ? 'line-through' : 'none'}">{{ i + 1 }}</td>
        <td [ngStyle]="{'text-decoration': file.deleted ? 'line-through' : 'none'}">{{ file.id }}</td>
        <td [ngStyle]="{'text-decoration': file.deleted ? 'line-through' : 'none'}">
          <ng-container *ngIf="file.azureUrl; else plainFilename">
            <a href="javascript:void(0)" (click)="openExternalLink(file.azureUrl)" class="text-primary">
              {{ file.filename }}
            </a>
          </ng-container>
          <ng-template #plainFilename>{{ file.filename }}</ng-template>
        </td>
        <td [ngStyle]="{'text-decoration': file.deleted ? 'line-through' : 'none'}">{{ formatBytes(file.bytes) }}</td>
        <td [ngStyle]="{'text-decoration': file.deleted ? 'line-through' : 'none'}">{{ file.created_at}}</td>
        <td [ngStyle]="{'text-decoration': file.deleted ? 'line-through' : 'none'}">{{ file.status }}</td>
        <td>
          <div class="d-flex flex-wrap align-items-center">
            <span *ngFor="let tag of file.tags" class="badge bg-primary me-1 mb-1">
              {{ tag }}
              <button type="button" class="btn btn-sm btn-light ms-1 py-0 px-1" (click)="removeTag(file, tag)" style="line-height: 1; font-size: 0.8em;">&times;</button>
            </span>
            <input type="text" #tagInput class="form-control form-control-sm d-inline-block" style="width: 80px; display: inline-block;"
              (keydown.enter)="addTag(file, tagInput.value); tagInput.value=''; $event.preventDefault();" placeholder="Add tag">
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<!-- 如果 filelist 為空，顯示 loading 信息 -->
<div id="showstatus">{{loadingstatus}}</div>


<!-- Delete Confirmation Modal -->
<div class="modal fade" id="deleteConfirmModal" tabindex="-1" aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteConfirmModalLabel">Comfirm Window</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        File deletion cannot be undone. Are you sure you want to proceed?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="confirmDelete()">Comfirm</button>
      </div>
    </div>
  </div>
</div>
